import {useState} from 'react'

import {useSelector,useDispatch} from 'react-redux'

import {
	setPipelineAssignModal,
	assignOnbardingPipeline
} from '../slice'

import {
	dateToYMD
} from '../../../util/datetime'

import {
	useProspectiveClients,
	useOnboardingPipeline
} from '../hooks'

import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'

import DatePicker from 'react-datepicker'
import Select from 'react-select'

export default function PipelineAssignModal(){
	const dispatch = useDispatch()
	const {id,show} = useSelector(state=>state.growth.pipelines.assignModal)
	const {status:pipelineStatus,pipeline} = useOnboardingPipeline(id)
	const {status:prospectsStatus,prospects} = useProspectiveClients()

	const [selectedProspects,setSelectedProspects] = useState([])
	const [startDate,setStartDate] = useState(new Date())

	const onHide = ()=>{
		dispatch(setPipelineAssignModal({show:false,id:null}))
	}

	const [isAssigning,setIsAssigning] = useState(false)
	const handleAssign = ()=>{
		if(selectedProspects.length===0){
			window.alert('Please select at least one prospect to assign.')
			return
		}
		setIsAssigning(true)
		dispatch(assignOnbardingPipeline({
			pipeline_id:id,
			start_date:dateToYMD(startDate),
			user_id_numbers:selectedProspects.map(s=>s.value)
		})).then(()=>{
			setIsAssigning(false)
			setSelectedProspects([])
			onHide()
		})
	}

	const assignedUsers = pipeline?.users.map(u=>u.user_id_number) || []
	const options = prospects
		.filter(p=>!assignedUsers.includes(p.user_id_number))
		.map(p=>({
			value:p.user_id_number,
			label:p.user_name
		}))

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header>
				Assign Automation
			</Modal.Header>
			<Modal.Body>
				<strong>Select Prospects</strong>
				<Select 
					onChange={setSelectedProspects}
					selected={selectedProspects}
					options={options}
					isMulti
				/>
				<strong>Start Date</strong>
				<div>
					<DatePicker
						customInput={<Form.Control/>}
						onChange={setStartDate}
						selected={startDate}
					/>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button 
					disabled={isAssigning}
					onClick={handleAssign}
					variant="outline-success"
				>
					Assign Automation to Prospects {isAssigning&&<Spinner animation="border" size="sm"/>}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}